import React from 'react';
import { Link } from "react-router-dom";
import logoImg from '../../../assets/images/logo.png';
import bellWhite from '../../../assets/images/bell-white.svg';
import bellIcon from '../../../assets/images/bell.svg';
import userIcon from '../../../assets/images/user.jpg';
import Button from '../../../core/Button';
import Svg from '../Svg';

export default function VariableSubHeader() {

    return (
        <></>
        // <div className='site-header subheader d-flex align-items-center justify-content-end'>
        //     <div className="right-menu-wrap align-items-center d-flex justify-content-end">
        //         {/* <div className="dropdown saving-dropdown d-flex">
        //             <div className="dropdown savingdropdown">
        //                 <button className='d-flex align-items-center' type="button" id="dropdownCollection" data-bs-toggle="dropdown" aria-expanded="false">
        //                     <Svg name="auto-save" />

        //                     Auto saving
        //                 </button>
        //                 <ul className="dropdown-menu" aria-labelledby="dropdownCollection">
        //                     <li><a className="dropdown-item" href="#">Option1</a></li>
        //                     <li><a className="dropdown-item" href="#">Option2</a></li>
        //                     <li><a className="dropdown-item" href="#">Option3</a></li>
        //                 </ul>
        //             </div>

        //         </div> */}
        //         <div className='preview-btn'>
        //             < Button
        //                 type='default'
        //                 view='filled'
        //                 color='primary'
        //                 dense={false}
        //                 text='Preview'
        //                 icon={false}
        //                 rightIcon={false}
        //                 loading={false}
        //                 disabled={false}
        //                 fill={false}
        //             />
        //         </div>
        //     </div>
        // </div>

    )
}
